export const BOB_PRESALE_V2_ABI = [
  { type: "function", stateMutability: "view", name: "presaleState", inputs: [], outputs: [{ type: "uint8" }] },
  { type: "function", stateMutability: "view", name: "roundId", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", stateMutability: "view", name: "contributionWeiPerWallet", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", stateMutability: "view", name: "maxParticipants", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", stateMutability: "view", name: "participantCount", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", stateMutability: "view", name: "totalRaisedWei", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", stateMutability: "view", name: "developerWallet", inputs: [], outputs: [{ type: "address" }] },
  { type: "function", stateMutability: "view", name: "owner", inputs: [], outputs: [{ type: "address" }] },
  { type: "function", stateMutability: "view", name: "allowlisted", inputs: [{ type: "address" }], outputs: [{ type: "bool" }] },
  { type: "function", stateMutability: "view", name: "hasParticipated", inputs: [{ type: "address" }], outputs: [{ type: "bool" }] },
  { type: "function", stateMutability: "view", name: "contributedWei", inputs: [{ type: "address" }], outputs: [{ type: "uint256" }] },
  {
    type: "function",
    stateMutability: "view",
    name: "participantsPaged",
    inputs: [{ type: "uint256" }, { type: "uint256" }],
    outputs: [{ type: "address[]" }],
  },
  { type: "function", stateMutability: "nonpayable", name: "setPresaleState", inputs: [{ type: "uint8" }], outputs: [] },
  { type: "function", stateMutability: "nonpayable", name: "setContributionWeiPerWallet", inputs: [{ type: "uint256" }], outputs: [] },
  { type: "function", stateMutability: "nonpayable", name: "setMaxParticipants", inputs: [{ type: "uint256" }], outputs: [] },
  {
    type: "function",
    stateMutability: "nonpayable",
    name: "resetPresale",
    inputs: [{ type: "uint256" }, { type: "uint256" }, { type: "uint8" }],
    outputs: [],
  },
  { type: "function", stateMutability: "nonpayable", name: "addToAllowlist", inputs: [{ type: "address[]" }], outputs: [] },
  { type: "function", stateMutability: "nonpayable", name: "removeFromAllowlist", inputs: [{ type: "address[]" }], outputs: [] },
  { type: "function", stateMutability: "payable", name: "buy", inputs: [], outputs: [] },
  { type: "error", name: "NotOwner", inputs: [] },
  { type: "error", name: "NotLive", inputs: [] },
  { type: "error", name: "NotAllowlisted", inputs: [] },
  { type: "error", name: "AlreadyParticipated", inputs: [] },
  { type: "error", name: "WrongAmount", inputs: [] },
  { type: "error", name: "ParticipantCapReached", inputs: [] },
  { type: "error", name: "InvalidConfig", inputs: [] },
  { type: "error", name: "InvalidState", inputs: [] },
];

export default BOB_PRESALE_V2_ABI;
